import React from "react";
import { Helmet } from "react-helmet";
import DynamicLayout from "../../components/DynamicLayout";
import { useQuery, gql } from "@apollo/client";
import { Link } from "react-router-dom";
import { kebabCase } from "lodash";

const GET_TAGS = gql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;

const TagsPage = () => {
  const { loading, error, data } = useQuery(GET_TAGS);

  if (loading) return null;
  if (error) return <p>Error: {error.message}</p>;

  const { siteMetadata: { title }, allMarkdownRemark: { group } } = data;

  return (
    <DynamicLayout>
      <section className="section">
        <Helmet title={`Tags | ${title}`} />
        <div className="container content">
          <div className="columns">
            <div
              className="column is-10 is-offset-1"
              style={{ marginBottom: "6rem" }}
            >
              <h1 className="title is-size-2 is-bold-light">Tags</h1>
              <ul className="taglist">
                {group.map((tag) => (
                  <li key={tag.fieldValue}>
                    <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                      {tag.fieldValue} ({tag.totalCount})
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </DynamicLayout>
  );
};

export default TagsPage;
